import {withDialogContent} from './withDialogContent';
import {DialogContentStyle} from './DialogContentStyle';

/**
 * Component located between the Title and Action components in a Dialog.
 * Text, forms, and other types of content for your dialog will live in this component.
 * Scroll wheel automatically renders when content on Y axis exceeds dialog height.
 *
 * @component
 */
export const DialogContent = withDialogContent(DialogContentStyle);
